module.exports = __webpack_public_path__ + "media/images/subject_img/LAW-ca9c97acbd502b8570d7da58f12fed30.jpg";